// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2gYeF","logoContainer":"styles_logoContainer__GiHc6","headphones":"styles_headphones__NY-Pj","audio":"styles_audio__3dcas"};